import { format } from "date-fns";
import { useState } from "react";


import React from "react";
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hook.ts";
import { AppointmentsDTO } from "./dto.ts";
import { findByIdAppointment, setModalAppointmentType, setNewAppointmentModal } from "./slice.ts";
import { AppointmentTooltip } from "./tooltip.tsx";

interface Props {
    height: string;
    width: string;
    appointment: AppointmentsDTO;
    offset: string;
    setAppointment: (appointment: AppointmentsDTO) => void;
}
export function WeekAppointment(props: Props) {
    const { height, appointment, width, offset, setAppointment } = props;
    const [visible, setVisible] = useState(false);
    const [mouseY, setMouseY] = useState(0);
    const [mouseX, setMouseX] = useState(0);

    const isLastColumn = new Date(appointment.startDate).getDay() === 0;

    const dispatch = useAppDispatch()
    const layoutState = useAppSelector(state => state.layout)

    return (
        <div
            onClick={() => {
                dispatch(setModalAppointmentType("edit"));
                dispatch(findByIdAppointment(appointment.id));
                dispatch(setNewAppointmentModal(true));
                setAppointment(appointment)
            }}
            style={{
                height,
                width,
                minWidth: "5px",
                minHeight: "16px",
                left: offset,
                padding: "0 2px",
            }}
            key={appointment.id}
            className="absolute cursor-pointer right-0 top-0 z-10"
        >
            <div
                onMouseEnter={() => setVisible(true)}
                onMouseMove={(e) => { !visible && setMouseY(e.clientY); !visible && setMouseX(e.clientX) }}
                onMouseLeave={() => setVisible(false)}
                style={{
                    backgroundColor: layoutState.theme[100],
                    color: layoutState.theme[800],
                    borderColor: layoutState.theme[300],
                }}
                className="h-full text-text-xs font-bold w-full rounded gap-2 flex"
            >
                <AppointmentTooltip visible={visible} appointment={appointment} isLastColumn={isLastColumn} mouseY={mouseY} mouseX={mouseX} />
                <div
                    className="h-full flex rounded flex-shrink-0"
                    style={{
                        backgroundColor: layoutState.theme[800],
                        width: "5px",
                        flexBasis: "5px",
                    }}
                />
                <span className="pr-2 w-full crop-text inline-block">
                    {appointment.title} -{" "}
                    <span className="font-normal text-right">
                        {format(appointment.startDate!, "HH:mm")}
                    </span>
                </span>
            </div>
        </div>
    );
}


